<script setup>
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';

import SubscriptionsTable from '../components/SubscriptionsTable.vue';
import { useAppStore } from '../store/app';

const store = useAppStore();
const router = useRouter();
const route = useRoute();

const onPushToCustomerTransaction = (customer) => {
  router.push(`/transactions/${customer?.customerId}/${customer?.subscriptionId}`);
};

/**
 * Fetch list of users bases on provided `productId`
 */
onMounted(() => {
  const { productId } = route.params;
  store.fetchAllSubscriptionTypes();
  store.fetchAllBetMakersSubLevels();
  store.fetchAllBetMakersProducts();
  store.fetchCustomersByProductId({ productId: productId });
});

const currentProduct = computed(() => {
  return store.products.find((product) => product.id === Number(route.params?.productId));
});
</script>

<script>
// normal `<script>`, executed in module scope (only once)
// declare additional options
export default {
  inheritAttrs: false,
  customOptions: {},
};
</script>

<template inheritAttrs="false">
  <div class="customers">
    <SubscriptionsTable
      :customers="store.customersByProduct"
      :rowAction="onPushToCustomerTransaction"
      :product="currentProduct" />
  </div>
</template>

<style scoped lang="scss">
.customers {
  margin-top: 13px;

  &__filters {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    input {
      text-indent: 43px;
      height: 45px;
      width: 290px;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px 0px;
      border: 1px solid rgba(var(--v-theme-background-tertiary));
      border-radius: 100px;
      outline: none;
    }

    select {
      height: 45px;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px 0px;
      background: white;
      padding-left: 20px;
      border-radius: 100px;
      padding-right: 20px;
    }
  }

  &__form-group {
    position: relative;

    i {
      left: 13px;
      top: 10px;
      position: absolute;
    }
  }
}
</style>
